// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigationBlock__Or7E3 {
  padding-top: 2px;
  padding-bottom: 2px;
  display: flex;
  align-items: center;
}

.navigationCounter__ETARM {
  font-size: 11px;
  line-height: 14px;
  color: var(--inputs-default-text);
  text-transform: uppercase;
  margin-right: 15px;
}

.navigatePrev__Zjka0,
.navigateNext__B9dAV {
  width: 20px;
  height: 20px;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
}
.navigatePrev__Zjka0 svg path,
.navigateNext__B9dAV svg path {
  stroke: var(--title-inputs-sections-drop-down-count);
}

.navigateNext__B9dAV {
  margin-left: 6px;
}
.navigateNext__B9dAV svg {
  transform: rotate(180deg);
}

.disabledLink__Wzkn4 {
  pointer-events: none;
}
.disabledLink__Wzkn4 svg path {
  stroke: var(--buttons-disable);
}
.disabledLink__Wzkn4:hover {
  background-color: inherit;
}

.separator__sv6ge {
  width: 1px;
  height: 20px;
  background-color: var(--inputs-disable-icon);
  margin-left: 5px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/Navigation/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;AAzEF;;AA4EA;;EAEE,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAzEF;AA4EI;;EACE,oDAAA;AAzEN;;AA8EA;EACE,gBAAA;AA3EF;AA4EE;EACE,yBAAA;AA1EJ;;AA8EA;EACE,oBAAA;AA3EF;AA6EE;EACE,8BAAA;AA3EJ;AA8EE;EACE,yBAAA;AA5EJ;;AAgFA;EACE,UAAA;EACA,YAAA;EACA,4CAAA;EACA,gBAAA;EACA,iBAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.navigationBlock {\n  padding-top: 2px;\n  padding-bottom: 2px;\n  display: flex;\n  align-items: center;\n}\n\n.navigationCounter {\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--inputs-default-text);\n  text-transform: uppercase;\n  margin-right: 15px;\n}\n\n.navigatePrev,\n.navigateNext {\n  width: 20px;\n  height: 20px;\n  user-select: none;\n  text-align: center;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n\n  svg {\n    path {\n      stroke: var(--title-inputs-sections-drop-down-count);\n    }\n  }\n}\n\n.navigateNext {\n  margin-left: 6px;\n  svg {\n    transform: rotate(180deg);\n  }\n}\n\n.disabledLink {\n  pointer-events: none;\n\n  svg path {\n    stroke: var(--buttons-disable);\n  }\n\n  &:hover {\n    background-color: inherit;\n  }\n}\n\n.separator {\n  width: 1px;\n  height: 20px;\n  background-color: var(--inputs-disable-icon);\n  margin-left: 5px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationBlock": `navigationBlock__Or7E3`,
	"navigationCounter": `navigationCounter__ETARM`,
	"navigatePrev": `navigatePrev__Zjka0`,
	"navigateNext": `navigateNext__B9dAV`,
	"disabledLink": `disabledLink__Wzkn4`,
	"separator": `separator__sv6ge`
};
module.exports = ___CSS_LOADER_EXPORT___;
